import React, { useEffect, useMemo, useRef, useState } from 'react';

//styles
import * as S from './styles';
import * as A from '../../styles/shared-components';
import themes from '../../styles/themes';
//import "./slider.scss";

//icons
import fafacebook from '../../icons/facebook.svg';
import fainstagram from '../../icons/instagram.svg';
//import fainstagram from '../../icons/instagram.svg';
import fatwitter from '../../icons/twitter.svg';
import falinkedin from '../../icons/linkedin.svg';

//components
import MenuBar from '../MenuBar';
import ContactButton from '../ContactButton';
import Background from '../Background';
import { ThemeProvider } from 'styled-components';
import Stack from '../Stack';
import Work from '../Work';
import Clients from '../Clients';
import Contact from '../Contact';
import SwipeableViews from 'react-swipeable-views-react-18-fix';
import { bindKeyboard } from 'react-swipeable-views-utils';
import { motion } from 'framer-motion'

//hooks
// import {
//   //useGoogleAnalytics,
//   useHovered,
//   useFindElementCenter,
//   useMousePosition,
//   useCanHover
// } from '../../utils/hooks';

import useIntroAnimation from './use-intro-animation';
import { AddressView } from '../AddressView/AddressView.component';


//env
//const { REACT_APP_ANALYTICS_ID } = process.env;

const AutoPlaySwipeableViews = bindKeyboard(SwipeableViews);

function Home() {
  const [index, setIndex] = useState(0);
  const [showScrollHint, setShowScrollHint] = useState(false);
  const currentYear = new Date().getFullYear();

  // refs
  const contentRef = useRef();
  const wheelLockRef = useRef(false);

  //custom hooks
  const { isAnimationDone, homePose } = useIntroAnimation(false);

  // side effects
  //useGoogleAnalytics(REACT_APP_ANALYTICS_ID, isAnimationDone);

  // computed
  const isBig = window.innerWidth > 100;
  const isMobile = window.innerWidth < 768;

  const slideStyle = {
    ...S.SlideStyle,
    alignItems: isMobile ? "flex-start" : "center",
    paddingTop: isMobile ? 10 : 0,
    paddingBottom: isMobile ? 10 : 0,
    overflowY: "auto"
  };

  const handleChangeIndex = newIndex => {
    setIndex(newIndex);
  };

  const handleWheelNavigate = event => {
    const isDesktop = window.innerWidth >= 1000;
    if (!isDesktop || wheelLockRef.current) return;

    const absDeltaY = Math.abs(event.deltaY);
    const absDeltaX = Math.abs(event.deltaX);
    const dominant = absDeltaX > absDeltaY ? event.deltaX : event.deltaY;

    if (Math.abs(dominant) < 18) return;

    const el = contentRef.current;
    const canScrollDown = el ? el.scrollHeight - el.scrollTop - el.clientHeight > 4 : false;
    const canScrollUp = el ? el.scrollTop > 4 : false;

    if ((dominant > 0 && canScrollDown) || (dominant < 0 && canScrollUp)) {
      return;
    }

    const direction = dominant > 0 ? 1 : -1;
    setIndex(prev => {
      const next = Math.max(0, Math.min(4, prev + direction));
      return next;
    });

    wheelLockRef.current = true;
    window.setTimeout(() => {
      wheelLockRef.current = false;
    }, 420);
  };

  const updateScrollHint = () => {
    const el = contentRef.current;
    if (!el) return;
    const canScrollDown = el.scrollHeight - el.scrollTop - el.clientHeight > 24;
    setShowScrollHint(canScrollDown);
  };

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const runCheck = () => updateScrollHint();
    runCheck();

    // Re-check after layout/paint to catch late content sizing on initial render.
    const raf1 = window.requestAnimationFrame(runCheck);
    const raf2 = window.requestAnimationFrame(() => window.requestAnimationFrame(runCheck));
    const timer = window.setTimeout(runCheck, 180);

    const onScroll = () => runCheck();
    const onResize = () => runCheck();

    el.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => runCheck());
      resizeObserver.observe(el);
    }

    return () => {
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
      window.clearTimeout(timer);
      el.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [index]);

  const social1 = async () => {
    window.open(`https://facebook.com/satyatech`);
  };
  const social2 = async () => {
    window.open(`https://instagram.com/satyatech`);
  };
  const social3 = async () => {
    window.open(`https://twitter.com/satyatech`);
  };
  const social4 = async () => {
    window.open(`https://www.linkedin.com/company/satyawati-llc`);
  };

  const clouds = [
    { variant: 'cumulus', top: 'calc(72px + 2vh)', left: '8%', width: 136, height: 54, scale: 1.02, opacity: 0.2, delay: 0, duration: 24, driftX: '92vw', driftY: '-10px', swayY: 8, swayDuration: 6.6 },
    { variant: 'cirrus', top: 'calc(72px + 7vh)', left: '58%', width: 132, height: 42, scale: 0.9, opacity: 0.12, delay: 0.3, duration: 20, driftX: '-95vw', driftY: '-8px', swayY: 7, swayDuration: 5.2, blur: 0.8 },
    { variant: 'stratus', top: 'calc(72px + 14vh)', left: '18%', width: 172, height: 48, scale: 0.9, opacity: 0.14, delay: 0.45, duration: 26, driftX: '86vw', driftY: '-6px', swayY: 9, swayDuration: 7.1 },
    { variant: 'stormEdge', top: 'calc(72px + 20vh)', left: '64%', width: 126, height: 50, scale: 0.95, opacity: 0.13, delay: 0.2, duration: 22, driftX: '-88vw', driftY: '-9px', swayY: 8, swayDuration: 5.8 },
    { variant: 'cumulus', top: 'calc(72px + 5vh)', left: '30%', width: 110, height: 44, scale: 0.82, opacity: 0.11, delay: 0.6, duration: 23, driftX: '82vw', driftY: '-7px', swayY: 7, swayDuration: 6.2, blur: 0.7 },
    { variant: 'stratus', top: 'calc(72px + 18vh)', left: '78%', width: 118, height: 40, scale: 0.86, opacity: 0.1, delay: 0.8, duration: 27, driftX: '-84vw', driftY: '-5px', swayY: 8, swayDuration: 6.8, blur: 0.75 },
    { variant: 'cirrus', top: 'calc(72px + 11vh)', left: '46%', width: 98, height: 34, scale: 0.74, opacity: 0.09, delay: 0.4, duration: 19, driftX: '98vw', driftY: '-7px', swayY: 6, swayDuration: 5.4, blur: 0.9 }
  ];

  const cloudMotions = useMemo(
    () =>
      clouds.map(cloud => ({
        ...cloud,
        duration: Number((16 + Math.random() * 40).toFixed(2)),
        swayDuration: Number((8 + Math.random() * 12).toFixed(2)),
        delay: Number((Math.random() * 2.5).toFixed(2))
      })),
    []
  );


  return (
    <ThemeProvider theme={themes['dark']}>
      <S.Home>
        <Background night={true} startLoadingLight={isAnimationDone} show={isBig} />

        <S.CloudsLayer>
          {cloudMotions.map((cloud, i) => (
            <S.Cloud
              key={i}
              top={cloud.top}
              left={cloud.left}
              variant={cloud.variant}
              width={cloud.width}
              height={cloud.height}
              radius={cloud.radius}
              scale={cloud.scale}
              opacity={cloud.opacity}
              tint={cloud.tint}
              glow={cloud.glow}
              glowSoft={cloud.glowSoft}
              delay={cloud.delay}
              duration={cloud.duration}
              driftX={cloud.driftX}
              driftY={cloud.driftY}
              swayY={cloud.swayY}
              swayDuration={cloud.swayDuration}
              blur={cloud.blur}
            />
          ))}
        </S.CloudsLayer>

        <MenuBar
          className="menubar"
          setIndex={setIndex}
          activeIndex={index}
        />

        <S.Content ref={contentRef}>
          {/* {index} */}
          <S.TextContent isAnimationDone={isAnimationDone} pose={homePose}>
            {/* <S.Title> SatyaTech </S.Title> */}
            <S.Subtitle>
              <AutoPlaySwipeableViews
                resistance
                animateHeight
                className="tabs-content"
                //interval={30000}
                enableMouseEvents={true}
                index={index}
                onChangeIndex={handleChangeIndex}
                onWheel={handleWheelNavigate}
                slideStyle={slideStyle}
              >
                <S.Satya>
                  <S.MainText>
                    <div>
                      <center>
                        <div>
                          <h2>We're an independent software company.</h2>
                          <span>
                            We design and build reliable web and mobile software tailored to your business goals.
                            From intuitive UX/UI to long-term maintenance and performance optimization,
                            we deliver end-to-end solutions that help companies scale with confidence.
                          </span>
                        </div>
                        <A.Space />
                        <ContactButton startLoading={isAnimationDone} setIndex={setIndex} />
                      </center>
                    </div>
                  </S.MainText>
                </S.Satya>

                <Stack />

                <Work />

                <Clients />

                <div>
                  <center>
                    <h2>Contact Us</h2>
                  </center>
                  <Contact />
                </div>

              </AutoPlaySwipeableViews>
            </S.Subtitle>

            <A.Space />
          </S.TextContent>
          {showScrollHint ? <S.ScrollHint><S.ScrollHintIcon /></S.ScrollHint> : null}
        </S.Content>
        <S.Footer
          compact={index !== 0}
          as={motion.div}
          variants={{
            visible: { opacity: 1, y: 0 },
            hidden: { opacity: 0, y: 30 }
          }}
          initial="hidden"
          animate="visible"
        >
          {index === 0 ? <AddressView/> : null}
          <S.CopyrightText>{`Copyright © ${currentYear}, Satyawati LLC`}</S.CopyrightText>

          {/*
            <S.Links2>
              <S.Social
                onClick={social1}
                role="button"
                tabIndex={0}
                onKeyPress={e => {
                  if ((e.which === 13 || e.which === 32)) {
                    social1(e);
                  }
                }}
              >
                <S.SocialIcon icon={fafacebook} />
              </S.Social>
              <S.Social
                onClick={social2}
                role="button"
                tabIndex={0}
                onKeyPress={e => {
                  if ((e.which === 13 || e.which === 32)) {
                    social2(e);
                  }
                }}
              >
                <S.SocialIcon icon={fainstagram} />
              </S.Social>
              <S.Social
                onClick={social3}
                role="button"
                tabIndex={0}
                onKeyPress={e => {
                  if ((e.which === 13 || e.which === 32)) {
                    social3(e);
                  }
                }}
              >
                <S.SocialIcon icon={fatwitter} />
              </S.Social>
              <S.Social
                onClick={social4}
                role="button"
                tabIndex={0}
                onKeyPress={e => {
                  if ((e.which === 13 || e.which === 32)) {
                    social4(e);
                  }
                }}
              >
                <S.SocialIcon icon={falinkedin} />
              </S.Social>
            </S.Links2>
            <S.Links>
              <S.Link href="mailto:contact@satyatech.xyz">Mail Us</S.Link>
              <S.Link onClick={() => handleChangeIndex(0)}>Home</S.Link>
              <S.Link onClick={() => handleChangeIndex(1)}>Services</S.Link>
              <S.Link onClick={() => handleChangeIndex(2)}>Work</S.Link>
              <S.Link onClick={() => handleChangeIndex(3)}>Clients</S.Link>
              <S.Link onClick={() => handleChangeIndex(4)}>Contact us</S.Link>
            </S.Links> 
          */}
        </S.Footer>
      </S.Home>
    </ThemeProvider>
  );
}

export default Home;
